/* LSC Lottie loader (Claude 10-29). The Lottie player (lottie_light, ~165 KB)
   is only fetched when a page actually needs it: any [data-lottie] element
   scrolled into view, or the first real add-to-cart click (plays the white
   check in the button). theme.liquid provides the asset URLs on window.__LSC. */
(function () {
  'use strict';
  var L = window.__LSC = window.__LSC || {};
  if (!L.lottieSrc) return;
  var REDUCE = window.matchMedia('(prefers-reduced-motion: reduce)');
  var loading = null;

  function load() {
    if (window.lottie) return Promise.resolve(window.lottie);
    if (loading) return loading;
    loading = new Promise(function (resolve, reject) {
      var s = document.createElement('script');
      s.src = L.lottieSrc;
      s.async = true;
      s.onload = function () { document.body.classList.add('lsc-lottie-ready'); resolve(window.lottie); };
      s.onerror = reject;
      document.head.appendChild(s);
    });
    return loading;
  }

  function mount(el) {
    if (el._lscLottie) return;
    el._lscLottie = true;
    var path = el.getAttribute('data-lottie');
    if (!path) return;
    var loop = el.hasAttribute('data-loop');
    var autoplay = !el.hasAttribute('data-hover');
    load().then(function (lottie) {
      var anim = lottie.loadAnimation({
        container: el,
        renderer: 'svg',
        loop: loop,
        autoplay: autoplay && !REDUCE.matches,
        path: path,
        rendererSettings: { progressiveLoad: true, preserveAspectRatio: 'xMidYMid meet' }
      });
      el._lscAnim = anim;
      if (REDUCE.matches) anim.addEventListener('DOMLoaded', function () { anim.goToAndStop(anim.totalFrames - 1, true); });
      if (el.hasAttribute('data-hover')) {
        var host = el.closest('a, button, .card-wrapper') || el;
        host.addEventListener('mouseenter', function () { anim.setDirection(1); anim.play(); });
        host.addEventListener('mouseleave', function () { anim.setDirection(-1); anim.play(); });
      }
    }).catch(function () {});
  }

  function scan() {
    var els = document.querySelectorAll('[data-lottie]');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) { for (var i = 0; i < els.length; i++) mount(els[i]); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { mount(en.target); io.unobserve(en.target); } });
    }, { rootMargin: '200px 0px' });
    for (var j = 0; j < els.length; j++) if (!els[j]._lscLottie) io.observe(els[j]);
  }

  /* Add-to-cart check: rides on the same click add-to-cart-fx.js uses to flash
     .atc-added. The check sits inside the button; lsc-lottie.css makes room. */
  function atcCheck(btn) {
    if (REDUCE.matches || !L.lottieCheck) return;
    load().then(function (lottie) {
      if (!btn.classList.contains('atc-added')) return;
      var old = btn.querySelector('.lsc-atc-check');
      if (old) old.remove();
      var box = document.createElement('span');
      box.className = 'lsc-atc-check';
      box.setAttribute('aria-hidden', 'true');
      btn.appendChild(box);
      var anim = lottie.loadAnimation({ container: box, renderer: 'svg', loop: false, autoplay: true, path: L.lottieCheck });
      var done = function () { if (box.parentNode) box.parentNode.removeChild(box); try { anim.destroy(); } catch (e) {} };
      setTimeout(done, 1600);
    }).catch(function () {});
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.product-form__submit, .quick-add__submit, .sticky-atc__button');
    if (!btn || btn.hasAttribute('disabled') || btn.getAttribute('aria-disabled') === 'true') return;
    if (!btn.closest('product-form') && !btn.classList.contains('sticky-atc__button')) return;
    setTimeout(function () { atcCheck(btn); }, 0);
  }, true);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
  document.addEventListener('shopify:section:load', scan);
  L.lottieScan = scan;
})();
